import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SegmentCohortsCreate = lazy(() =>
  import("@segments/segment-cohorts/edit/SegmentCohortEdit").then((module) => ({
    default: module.SegmentCohortCreateNRO,
  }))
);

export const segmentCohortsCreateNRO: NavigationRoutingObject = {
  section: "audience",
  Component: SegmentCohortsCreate,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("segment-cohorts-create-nro-heading", "Segment Extensions Create NRO"),
  pageNameForTracking: () => "Segment Extensions Create NRO",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("segment-cohorts-create-nro-description", "Create a segment extension"),
  icon: "nav-system-segment-extensions",
  featureLimitationKeys: ["can_only_view_landing_page_segment_extensions"],
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/segment_cohorts/segment_cohorts/:appGroupId",
};
